import type { GridCellModesModel, GridCellParams } from "@mui/x-data-grid-premium";
import { GridCellModes } from "@mui/x-data-grid-premium";
import { useCallback, useState } from "react";

// https://mui.com/x/react-data-grid/recipes-editing/
const useSingleClickGridEditing = () => {
  const [cellModesModel, setCellModesModel] = useState<GridCellModesModel>({});

  const handleCellClick = useCallback((params: GridCellParams, event: React.MouseEvent) => {
    if (!params.isEditable) {
      return;
    }

    // Ignore portal
    const targetElement = event.target as Element;
    if (targetElement.nodeType === 1 && !event.currentTarget.contains(targetElement)) {
      return;
    }

    setCellModesModel((prevModel) => {
      return {
        // Revert the mode of the other cells from other rows
        ...Object.keys(prevModel).reduce(
          (acc, id) => ({
            ...acc,
            [id]: Object.keys(prevModel[id] ?? {}).reduce(
              (acc2, field) => ({
                ...acc2,
                [field]: { mode: GridCellModes.View },
              }),
              {}
            ),
          }),
          {}
        ),
        [params.id]: {
          // Revert the mode of other cells in the same row
          ...Object.keys(prevModel[params.id] || {}).reduce(
            (acc, field) => ({ ...acc, [field]: { mode: GridCellModes.View } }),
            {}
          ),
          [params.field]: { mode: GridCellModes.Edit },
        },
      };
    });

    setTimeout(() => {
      const input = targetElement.querySelector("input");
      if (input) {
        input.select();
      }
    });
  }, []);

  return { cellModesModel, setCellModesModel, handleCellClick };
};

export default useSingleClickGridEditing;
